export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            tableData: [],
            total: 0,
            id: "",
            queryInfo: {
                pageNo: 1,
                pageSize: 20,
                keywords: ""
            },
            isLoading: false
        };
    },
    mounted () {
        this.getDataList();
    },
    watch: {
        modelValue: {
            handler (newVal) {
                this.id = newVal;
            },
            immediate: true,
            deep: true
        },
        id (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        /* 搜索 */ upsearch () {
            this.queryInfo.pageNo = 1;
            this.getDataList();
        },
        /* 重置 */ refreshSearch () {
            this.queryInfo = this.$options.data().queryInfo;
            this.getDataList();
        },
        //! 分页功能
        paginationChange (page) {
            this.queryInfo.pageNo = page;
            this.getDataList();
        },
        //! 页码切换
        pageSizeChange (size) {
            this.queryInfo.pageSize = size;
            this.getDataList();
        },
        async getDataList () {
            this.isLoading = true;
            let res = await this.$API.user.lesson.offlineLessonList.get(this.queryInfo);
            this.isLoading = false;
            if (res?.code === 1) {
                this.tableData = res?.data?.data || [];
                this.total = res?.data?.total || 0;
            }
        }
    }
};
